import React, { Component } from "react";
// import ReactDOM from "react-dom";
import "./index.scss";

import { assetImg } from "@/modules/moduleImporter";
import { IPokerDiceHistoryType, IGameResultHistoryProps } from "@/types/GameHistoryTypes";

interface IProps extends IGameResultHistoryProps {
	history: IPokerDiceHistoryType[];
	activeGameCount: number;
	historyBlink: boolean;
}

export default class M14 extends Component<IProps> {
	History(props) {
		const alternatingStyle = "sl-roadmap-alternating";

		if (!props.angka2) {
			console.warn("Warning: empty angka2 on m14, props:", props);
			return null;
		}
		
		const angka: string[] = props.angka2.split(",");

		let odds = 0, evens = 0,
			bigs = 0;
		
		let r = 0;
		const res2 = [];

		//Iterate over angka2
		for (const i of angka) {
			//Odd/Even
			if (parseInt(i, 10) % 2)
				odds++;
			else evens++;

			//Big/Small
			if (parseInt(i, 10) > 3)
				bigs++;

			//Reds/Blacks
			if (i.indexOf("r") !== -1)
				r = r + i.indexOf("r");

			const a = i.slice(-1);
			const b = i.replace(/r|b/g, "");
			res2.push(a + b);
		}

		const colour = (r >= 3) ? "Red" : "Black";
		const size = (bigs > 2) ? "Big" : "Small";
		const oddEven = odds > evens ? "Odd" : "Even";

		const longTextClass = (props.angka3.length >= 12 ? " smaller-text" : "");
		
		return (
			props.activeGameCount === 1 ? (
				<div className={"results " + (props.blink ? alternatingStyle : "") + longTextClass}>
					<div className="image-result">
						{
							res2.slice(0, 6).map((item, idx) =>
								assetImg("m14",
									item.split("").reverse().join("").toUpperCase(),
									"m14_ir_" + idx)
							)
						}
					</div>
					<div className="details-result">
						<div className="details-top">
							<div className={(colour === "Red") ? "diamon sl-red-darken" : "diamon sl-black"}></div>
							<div className="detail-1 sl-green-new">{(size === "Small") ? "S" : "B"}</div>
							<div className="detail-2 sl-cyan-new">{(oddEven === "Even") ? "E" : "O"}</div>
						</div>
						<div className="details-bottom">
							<div className="detail-result sl-green-old">
								{ props.angka3 }
							</div>
						</div>
					</div>
				</div>
				) : (
				<div className={"results " + (props.blink ? alternatingStyle : "") + longTextClass}>
					<div className="topPart">
						<div className="image-result">
							{
								res2.slice(0, 6).map((item, idx) =>
									assetImg("m14", item.split("").reverse().join("").toUpperCase(), `grh_m14_dice_${idx}`)
								)
							}
						</div>
						<div className="detail-result">
							{ props.angka3 }
						</div>
					</div>
					<div className="bottomPart">
						<div className="detail">
							<div className={(colour === "Red") ? "diamon sl-red-darken" : "diamon sl-black"}></div>
							<div>{colour}</div>
						</div>
						<div className="detail">{size}</div>
						<div className="detail">{oddEven}</div>
					</div>
				</div>
				)
			);
	}
	
	
	render() {
		const reversedHistory = this.props.history.slice(0).reverse();
		const History = this.History;
		const historyBlink = this.props.historyBlink;
		
		return (
			<div className={"history-m14 history-container"}>
			{
				reversedHistory.slice(0, 6).map((data, idx) =>
					<History
						activeGameCount={this.props.activeGameCount}
						angka2={data.angka2}
						angka3={data.angka3}
						blink={historyBlink && idx === 0}
						key={idx} />
				)
			}
			</div>
		);
	}
}
